import { render, staticRenderFns } from "./EffeciencyTop3.vue?vue&type=template&id=174e89c4&scoped=true&"
import script from "./EffeciencyTop3.vue?vue&type=script&lang=js&"
export * from "./EffeciencyTop3.vue?vue&type=script&lang=js&"
import style0 from "./EffeciencyTop3.vue?vue&type=style&index=0&id=174e89c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174e89c4",
  null
  
)

export default component.exports